import oDataQuery from 'odata-query'
import { toast } from '@sales-center/components'

import { ENTITY_TYPES, ODataResponse } from '@sales-center/common'
import { get, isAPIError } from '@user/store/services/crud'

import type {
  ActivitySummaryDTO,
  ActivitySummaryRow,
  ActivitySummaryTab,
} from '../typings'
import { baseUrl } from '../constants'
import { ActivitySummaryHelpers } from '../helpers'
import { setActivitySummaryTableStateActionCreator as setTableState } from '../state'

export async function fetchActivitySummary(props: {
  page: number
  orderBy: string
  pageSize: number
  tab: ActivitySummaryTab
  normalizedFilters: string[]
}) {
  const { tab, page, orderBy, pageSize, normalizedFilters } = props

  const query = oDataQuery<ActivitySummaryDTO>({
    orderBy,
    count: true,
    top: pageSize,
    skip: page * pageSize,
    filter: [
      ...normalizedFilters,
      ActivitySummaryHelpers.tabToODataFilter(tab),
    ],
  })

  const response = await get(`${baseUrl}${query}`)

  if (!response.ok) {
    const result = await response.json()

    if (isAPIError(result)) {
      toast.error(result.Message)
    } else {
      toast.error('Failed to fetch Activity Summary')
    }

    return setTableState({
      rows: [],
      totalRows: 0,
      loading: false,
    })
  }

  const data: ODataResponse<ActivitySummaryDTO> = await response.json()

  const rows = data.value.map<ActivitySummaryRow>((x) => {
    return {
      ...x,
      dueDate: x.dueDate,
      createdDate: x.createdDate,
      startDate: x.startDate !== null ? x.startDate : null,
      // SH-2338: three-way. The old two-way map sent anything that was not
      // 'Lead' to Opportunity, so an unattached row (entityType null) became an
      // Opportunity and RelatedToCell rendered a live link to
      // #/opportunities/null.
      entityType:
        x.entityType === 'Lead'
          ? ENTITY_TYPES.Lead
          : x.entityType === 'Opportunity'
            ? ENTITY_TYPES.Opportunity
            : null,
    }
  })

  const totalRows = data['@odata.count']

  return setTableState({
    rows,
    totalRows,
    loading: false,
  })
}
